const sr: Record<string, string> = {
  'nav.blog': 'Blog',
  'nav.virtualOffice': 'Virtuelna kancelarija',
  'nav.coworking': 'Coworking',
  'nav.accounting': 'Računovodstvo i pravo',
  'nav.contact': 'Kontakt',
  'nav.clientPortal': 'Klijentski portal',
  'nav.getStarted': 'Počnite',
  'nav.menu': 'Meni navigacije',
  'hero.badge': 'Poverenje 400+ kompanija iz 7 zemalja',
  'hero.title1': 'Virtuelna kancelarija u Beogradu',
  'hero.title2': 'za strane i domaće firme',
  'hero.title3': '',
  'hero.desc': 'Otvarate ili selite firmu u Srbiju, a niste sigurni da li je adresa u skladu sa propisima i da li će proći u APR-u? Dobijate 100% legalnu poslovnu adresu, registraciju i administraciju, u skladu sa zakonima Republike Srbije, aktivnu za 48h od potpisivanja.',
  'hero.trust1': 'Poslovna adresa u Beogradu i Kovinu (PU Pančevo); Loznica uskoro, iskažite interesovanje',
  'hero.trust2': 'Pomoć pri otvaranju firme u Srbiji',
  'hero.trust3': 'Prijem i prosleđivanje pošte',
  'hero.trust4': 'Računovodstvo i administrativna podrška',
  'hero.cta1': 'Pokrenite poslovanje u Srbiji već danas',
  'hero.cta2': 'Kako funkcioniše',
  'hero.reviews': 'od 180+ verifikovanih recenzija klijenata',
  'hero.clientPortal': 'Klijentski portal',
  'hero.active': 'Aktivan',
  'hero.documents': 'Dokumenti',
  'hero.invoices': 'Fakture',
  'hero.plan': 'Plan',
  'hero.address': 'Adresa',
  'hero.liveActivity': 'Aktivnost uživo',
  'hero.docUploaded': 'Novi dokument otpremljen',
  'hero.invoicePaid': 'Faktura plaćena',
  'hero.mailForwarded': 'Pošta prosleđena',
  'hero.newClients': '12 novih klijenata',
  'hero.thisMonth': 'Ovog meseca',
  'hero.mockCompany': 'EVI Solutions DOO',
  'hero.activityCompany1': 'Tehno sistem d.o.o.',
  'hero.activityCompany2': 'Jadranska trgovina d.o.o.',
  'hero.activityCompany3': 'Stojanović konsalting d.o.o.',
  'hero.timeAgo2m': 'pre 2 min',
  'hero.timeAgo18m': 'pre 18 min',
  'hero.timeAgo1h': 'pre 1 č',
  'hero.kpi.documentsSub': '2 nova ove nedelje',
  'hero.kpi.invoicesSub': '1 na čekanju plaćanja',
  'hero.kpi.planSub': 'Virtuelna kancelarija',
  'hero.kpi.addressValue': 'Beograd',
  'hero.kpi.addressSub': 'Topčiderska 14',
  'services.tag': 'Šta nudimo',
  'services.title': 'Poslovna adresa, prijem pošte i\nračunovodstvo na jednom mestu',
  'services.desc':
    'Bilo da ste strana kompanija koja uspostavlja srpsko prisustvo ili lokalni preduzetnik, Top14 kancelarijska rešenja pokrivaju registraciju, adresu i celokupnu podršku.',
  'services.mostPopular': 'Najpopularnije',
  'services.virtualOffice.tag': 'Poslovna adresa i registracija',
  'services.virtualOffice.title': 'Virtuelna kancelarija',
  'services.virtualOffice.desc':
    'Registrovane poslovne adrese u Beogradu (Topčiderska) i Kovinu (PU Pančevo). Lokacija Loznica uskoro, iskažite interesovanje. Uključuje prijem pošte, podršku pri registraciji kompanije i siguran portal za dokumente.',
  'services.virtualOffice.taxNote':
    'Alternativne lokacije mogu dodatno doprineti poreskoj optimizaciji u skladu sa vašim modelom poslovanja.',
  'services.virtualOffice.f1': 'Beograd – Topčiderska, opština Savski venac',
  'services.virtualOffice.f5': 'Kovin, PU Pančevo - najpovoljniji paušal u Srbiji',
  'services.virtualOffice.f6': 'Loznica, uskoro, blizu granice sa BiH (iskažite interesovanje)',
  'services.virtualOffice.f2': 'Podrška pri APR registraciji',
  'services.virtualOffice.f3': 'Pogodno za strane kompanije',
  'services.virtualOffice.f4': 'Portal za upravljanje dokumentima',
  'services.virtualOffice.price': '3.500 RSD',
  'services.virtualOffice.per': '/ mesec (~30 EUR)',
  'services.virtualOffice.learn': 'Saznajte više',
  'services.coworking.tag': 'Fleksibilan radni prostor',
  'services.coworking.title': 'Coworking prostor',
  'services.coworking.desc': 'Moderni stolovi i privatne kancelarije u centru Beograda. Gigabitni internet 1 Gbps, 3 sale za sastanke i miran prostor sa najviše 20 korisnika.',
  'services.coworking.price': '€89',
  'services.coworking.per': '/ mesec',
  'services.coworking.plans': 'Pogledajte planove',
  'services.accounting.tag': 'Poslovna podrška',
  'services.accounting.title': 'Računovodstvo i pravo',
  'services.accounting.desc': 'Knjigovodstvo, PDV registracija, poreske prijave i pravno savetovanje - na srpskom, engleskom, ruskom, turskom i nemačkom.',
  'services.accounting.cta': 'Besplatne konsultacije',
  'capitaale.aria': 'Preporučena aplikacija za paušalce',
  'capitaale.tag': 'Preporučeno za paušalce',
  'capitaale.desc':
    'Capitaale je aplikacija za preduzetnike koji naplaćuju iz inostranstva. Pravi saldo u dinarima posle kursa banke, paušalni limit uživo, upozorenje kada jedan klijent pređe 70% prihoda i faktura u EUR ili USD za 60 sekundi. Prvih 7 dana besplatno.',
  'capitaale.cta': 'Probaj 7 dana besplatno',
  'capitaale.external': 'Otvara Capitaale partner stranicu',
  'how.tag': 'Korak po korak',
  'how.title': 'Kako pokrećete poslovanje u Srbiji uz nas',
  'how.desc':
    'Vodimo vas kroz ceo proces, od prve ideje do potpuno operativne firme, bez komplikacija i gubljenja vremena.',
  'how.step1.title': 'Kratak konsultativni poziv',
  'how.step1.lead': 'Upoznajemo vaše potrebe i predlažemo najbolje rešenje',
  'how.step1.desc':
    'Razgovaramo o vašem poslovanju, ciljevima i obimu aktivnosti u Srbiji. Na osnovu toga predlažemo optimalan paket usluga.',
  'how.step1.badge': '15–30 min',
  'how.step2.title': 'Predlog saradnje i ugovor',
  'how.step2.lead': 'Dobijate jasan plan i sve uslove unapred',
  'how.step2.desc':
    'Šaljemo vam konkretan predlog usluga i primer ugovora. Sve je transparentno, bez skrivenih troškova.',
  'how.step2.check1': 'jasno definisano',
  'how.step2.check2': 'bez birokratije',
  'how.step3.title': 'Dozvola za poslovnu adresu',
  'how.step3.lead': 'Dobijate saglasnost za korišćenje naše adrese kao sedišta',
  'how.step3.intro': 'Od nas dobijate:',
  'how.step3.bullet1': 'dozvolu za prijavu naše adrese u APR-u',
  'how.step3.bullet2': 'dokumentaciju potrebnu za sedište firme',
  'how.step3.bullet3': 'prijem pošte na toj adresi',
  'how.step3.badge': 'u proseku nekoliko dana',
  'how.step4.title': 'Aktivacija i rad kroz portal',
  'how.step4.lead': 'Sve dalje rešavate na jednom mestu',
  'how.step4.desc': 'Nakon potpisivanja, otvaramo vam nalog na našem portalu gde:',
  'how.step4.bullet1': 'upravljate dokumentima',
  'how.step4.bullet2': 'komunicirate sa timom',
  'how.step4.bullet3': 'pratite fakture i usluge',
  'how.step4.badge': 'podrška 24/7',
  'how.cta': 'Pokrenite poslovanje bez komplikacija',
  'how.learnMore': 'Saznajte više',
  'vo.tag': 'Virtuelna kancelarija',
  'vo.title': 'Profesionalna beogradska\nadresa za vaše poslovanje',
  'vo.desc': 'Registrovana adresa na Topčiderskoj ulici, Beograd - savršeno za strane kompanije koje ulaze na srpsko tržište.',
  'vo.standard': 'Standard',
  'vo.premium': 'Premium',
  'vo.popular': 'Najpopularnije',
  'vo.month': '/ mesec',
  'vo.getStarted': 'Počnite',
  'vo.contact': 'Kontaktirajte nas',
  'vo.included': 'Uključeno u svim planovima',
  'cw.tag': 'Coworking prostor',
  'cw.title': 'Moderni radni prostori\nu centru Beograda',
  'cw.desc': 'Fleksibilni coworking prostori dizajnirani za produktivnost. Od hot desk opcija do privatnih kancelarija - pronađite savršen prostor za vaš tim.',
  'cw.hotDesk': 'Hot Desk',
  'cw.dedicatedDesk': 'Fiksni sto',
  'cw.privateOffice': 'Privatna kancelarija',
  'cw.month': '/ mesec',
  'cw.getStarted': 'Počnite',
  'cw.bookTour': 'Zakažite obilazak',
  'acc.tag': 'Računovodstvo i pravo',
  'acc.title': 'Kompletna finansijska i pravna\npodrška za vaše poslovanje',
  'acc.desc': 'Naš tim iskusnih računovođa i pravnih savetnika pruža sveobuhvatnu podršku za kompanije koje posluju u Srbiji.',
  'acc.basic': 'Osnovno',
  'acc.professional': 'Profesionalno',
  'acc.enterprise': 'Enterprise',
  'acc.month': '/ mesec',
  'acc.getStarted': 'Počnite',
  'acc.consultation': 'Besplatne konsultacije',
  'acc.pricing.title': 'Cenovnik računovodstvenih usluga',
  'acc.pricing.subtitle': 'Sve cene su u dinarima (RSD). Cene su minimalne i predmet su dogovora.',
  'acc.pricing.service': 'Naziv usluge',
  'acc.pricing.clientPrice': 'Cena za klijente',
  'acc.pricing.regularPrice': 'Redovna cena',
  'acc.pricing.unit': 'Jedinica mere / napomena',
  'acc.pricing.online': 'Online',
  'trust.tag': 'Zašto Top14',
  'trust.title': 'Poverenje kompanija\niz celog sveta',
  'trust.desc':
    'Više od 400 kompanija iz 7 zemalja za poslovno prisustvo u Srbiji bira Top14 kancelarijska rešenja.',
  'trust.companies': 'Aktivnih kompanija',
  'trust.countries': 'Zemalja',
  'trust.years': 'Godina iskustva',
  'trust.satisfaction': 'Zadovoljstvo klijenata',
  'contact.tag': 'Kontaktirajte nas',
  'contact.title': 'Top14 kancelarijska rešenja',
  'contact.desc': 'Spremni da uspostavite srpsko poslovno prisustvo? Pošaljite nam poruku i naš tim će odgovoriti u roku od jednog radnog dana.',
  'contact.address': 'Adresa',
  'contact.phone': 'Telefon',
  'contact.email': 'Email',
  'contact.hours': 'Radno vreme',
  'contact.hoursValue': 'Pon–Pet, 09:00–17:00 CET',
  'contact.addressValue': 'Topčiderska 14, 11000 Beograd, Srbija',
  'contact.phoneValue': '+381 62 262 221',
  'contact.emailValue': 'office@top14.rs',
  'contact.mapStreet': 'Topčiderska ulica',
  'contact.mapCity': 'Beograd, Srbija',
  'contact.responseTime': 'Tipično vreme odgovora',
  'contact.responseValue': 'Ispod 4 sata tokom radnog vremena',
  'contact.weRespond': 'Odgovaramo na',
  'contact.formTitle': 'Pošaljite nam poruku',
  'contact.formDesc': 'Odgovorićemo u roku od jednog radnog dana.',
  'contact.name': 'Ime i prezime *',
  'contact.emailField': 'Email adresa *',
  'contact.phoneField': 'Broj telefona za kontakt *',
  'contact.placeholderPhone': '+381 60 123 4567',
  'contact.errPhone': 'Unesite broj telefona.',
  'contact.company': 'Naziv kompanije',
  'contact.country': 'Zemlja',
  'contact.officeLocation': 'Lokacija virtuelne kancelarije *',
  'contact.selectOfficeLocation': 'Izaberite lokaciju…',
  'contact.location.belgrade': 'Beograd, Topčiderska - PU Savski venac',
  'contact.location.kovinPancevo': 'Kovin - PU Pančevo (najpovoljniji paušal u Srbiji)',
  'contact.location.loznica': 'Loznica, uskoro (blizu BiH); iskažite interesovanje',
  'contact.location.arandjelovac': 'Aranđelovac',
  'contact.errOfficeLocation': 'Izaberite lokaciju kancelarije.',
  'contact.service': 'Usluge od interesa *',
  'contact.selectService': 'Odaberite uslugu...',
  'contact.placeholderName': 'Marko Marković',
  'contact.placeholderEmail': 'marko@kompanija.rs',
  'contact.placeholderCompany': 'Primer d.o.o. Beograd',
  'contact.placeholderCountry': 'Nemačka',
  'contact.placeholderMessage':
    'Tražimo virtuelnu kancelariju u Beogradu i podršku pri registraciji predstavništva. Molimo vas za kratak opis koraka i okvirne cene.',
  'contact.serviceRequired': 'Izaberite bar jednu uslugu.',
  'contact.errName': 'Unesite ime i prezime.',
  'contact.errEmail': 'Unesite email adresu.',
  'contact.errEmailInvalid': 'Unesite ispravnu email adresu.',
  'contact.errMessage': 'Unesite poruku.',
  'contact.errMessageMin': 'Poruka mora imati najmanje 20 karaktera.',
  'contact.message': 'Poruka *',
  'contact.messageHint': 'Opišite vaše poslovne potrebe i specifična pitanja.',
  'contact.send': 'Pošaljite poruku',
  'contact.sending': 'Slanje...',
  'contact.successTitle': 'Poruka poslata',
  'contact.successDesc': 'Hvala na obraćanju. Naš tim će vas kontaktirati u roku od jednog radnog dana.',
  'contact.sendAnother': 'Pošaljite još jednu poruku',
  'contact.services.vo': 'Virtuelna kancelarija',
  'contact.services.cw': 'Coworking prostor',
  'contact.services.acc': 'Računovodstvo i pravna podrška',
  'contact.services.reg': 'Registracija kompanije',
  'contact.services.gen': 'Opšti upit',
  'contact.toast': 'Poruka poslata! Kontaktiraćemo vas u roku od jednog radnog dana.',
  'contact.errorSend': 'Slanje nije uspelo. Pokušajte ponovo za trenutak.',
  'footer.desc':
    'Top14 - profesionalne usluge virtuelne kancelarije, coworkinga i poslovne podrške za kompanije koje posluju u Srbiji.',
  'footer.services': 'Usluge',
  'footer.company': 'Kompanija',
  'footer.contact': 'Kontakt',
  'footer.about': 'O nama',
  'footer.howItWorks': 'Kako funkcioniše',
  'footer.pricing': 'Cene',
  'footer.clientPortal': 'Klijentski portal',
  'footer.privacy': 'Politika privatnosti',
  'footer.terms': 'Uslovi korišćenja',
  'footer.cookies': 'Politika kolačića',
  'legal.backHome': 'Nazad na početnu',
  'footer.rights': '© 2026 EVI Solutions DOO. Sva prava zadržana.',
  'portal.adminDashboard': 'Admin Dashboard',
  'portal.operatorDashboard': 'Operaterski dashboard',
  'portal.roleBadgeAdmin': 'Administrator',
  'portal.roleBadgeOperator': 'Operater',
  'portal.roleBadgeClient': 'Klijent',
  'portal.clientDashboard': 'Klijentski Dashboard',
  'portal.signOut': 'Odjava',
  'portal.publicSite': 'Javni sajt',
  'portal.settings': 'Podešavanja',
  'portal.password.title': 'Promena lozinke',
  'portal.password.hint': 'Za naloge koji se prijavljuju emailom i lozinkom.',
  'portal.password.current': 'Trenutna lozinka',
  'portal.password.new': 'Nova lozinka',
  'portal.password.confirm': 'Potvrdite novu lozinku',
  'portal.password.submit': 'Sačuvaj lozinku',
  'portal.password.saving': 'Čuvanje…',
  'portal.password.changed': 'Lozinka je uspešno promenjena.',
  'portal.password.wrongCurrent': 'Trenutna lozinka nije ispravna.',
  'portal.password.mismatch': 'Nove lozinke se ne poklapaju.',
  'portal.password.tooShort': 'Lozinka mora imati najmanje 8 karaktera.',
  'portal.password.changeFailed': 'Lozinka nije mogla da se promeni.',
  'portal.password.noEmail': 'Nalog nema email adresu.',
  'portal.darkMode': 'Tamni režim',
  'portal.notifications': 'Obaveštenja',
  'portal.markAllRead': 'Označi sve kao pročitano',
  'portal.viewAll': 'Pogledaj sve',
  'portal.notificationsPageTitle': 'Notifikacije',
  'portal.notificationsUnreadHint': 'nepročitanih',
  'portal.notificationsAllCaughtUp': 'Sve je pregledano',
  'portal.notificationsEmpty': 'Nema notifikacija.',
  'portal.notificationsLoadError': 'Učitavanje notifikacija nije uspelo.',
  'portal.markAllReadDone': 'Sve je označeno kao pročitano.',
  'portal.notificationsNeedCompany': 'Notifikacije će biti dostupne kada se učita vaša kompanija.',
  'portal.notif.contactForm': 'Nova poruka sa kontakt forme: {{name}}',
  'portal.notif.newTask': 'Novi zahtev',
  'portal.profile': 'Profil',
  'portal.search': 'Pretraži kompanije, dokumente...',
  'portal.company': 'Kompanija',
  'portal.contactSupport': 'Kontaktirajte podršku',
  'portal.exportReport': 'Izvezi izveštaj',
  'portal.addCompany': 'Dodaj kompaniju',
  'portal.language': 'Jezik',
  'portal.openMenu': 'Otvori meni',
  'sidebar.main': 'Navigacija',
  'sidebar.dashboard': 'Pregled',
  'sidebar.myCompany': 'Moja kompanija',
  'sidebar.companies': 'Kompanije',
  'sidebar.documents': 'Dokumenti',
  'sidebar.invoices': 'Fakture',
  'sidebar.users': 'Korisnici',
  'sidebar.calls': 'Primljeni pozivi',
  'sidebar.callsAdmin': 'Telefonski pozivi',
  'sidebar.contacts': 'Kontakt forma',
  'sidebar.notifications': 'Notifikacije',
  'sidebar.tasks': 'Zadaci',
  'sidebar.taskRequests': 'Zahtevi',
  'admin.tab.dashboard': 'Pregled',
  'admin.tab.companies': 'Kompanije',
  'admin.tab.documents': 'Dokumenti',
  'admin.tab.invoices': 'Fakture',
  'admin.tab.users': 'Korisnici',
  'admin.tab.tasks': 'Zadaci',
  'admin.tab.calls': 'Telefonski pozivi',
  'admin.tab.contacts': 'Kontakt forma',
  'admin.contacts.title': 'Upiti sa kontakt forme',
  'admin.contacts.subtitle': 'upita',
  'admin.contacts.newBadge': 'novih',
  'admin.contacts.unreadBadge': 'novo',
  'admin.contacts.refresh': 'Osveži',
  'admin.contacts.loading': 'Učitavanje…',
  'admin.contacts.empty': 'Nema upita.',
  'admin.contacts.loadError': 'Nije moguće učitati upite.',
  'admin.contacts.updateError': 'Čuvanje nije uspelo.',
  'admin.contacts.statusSaved': 'Status je sačuvan.',
  'admin.contacts.noteSaved': 'Beleška je sačuvana.',
  'admin.contacts.col.date': 'Datum',
  'admin.contacts.col.contact': 'Kontakt',
  'admin.contacts.col.office': 'Kancelarija',
  'admin.contacts.col.services': 'Usluge',
  'admin.contacts.col.status': 'Status',
  'admin.contacts.col.notes': 'Interna beleška',
  'admin.contacts.affiliate': 'Affiliate',
  'admin.contacts.notePlaceholder': 'Dogovor, sledeći korak…',
  'admin.contacts.saveNote': 'Sačuvaj belešku',
  'admin.contacts.openMessage': 'Poruka',
  'admin.contacts.close': 'Zatvori',
  'admin.contacts.status.new': 'Novo',
  'admin.contacts.status.contacted': 'Kontaktiran',
  'admin.contacts.status.no_show_negotiations': 'Nije se javio u pregovorima',
  'admin.contacts.status.in_discussion': 'U pregovorima',
  'admin.contacts.status.became_client': 'Postao korisnik',
  'admin.contacts.status.declined': 'Odustao / odbio',
  'admin.contacts.status.spam': 'Spam',
  'admin.cancel': 'Otkaži',
  'admin.filters.title': 'Filteri',
  'admin.filters.company': 'Kompanija',
  'admin.filters.allCompanies': 'Sve kompanije',
  'admin.filters.category': 'Tip dokumenta',
  'admin.filters.allCategories': 'Svi tipovi',
  'admin.filters.status': 'Status',
  'admin.filters.allStatuses': 'Svi statusi',
  'admin.filters.dateFrom': 'Od',
  'admin.filters.dateTo': 'Do',
  'admin.filters.priority': 'Hitnost',
  'admin.filters.allPriorities': 'Sve',
  'admin.filters.reset': 'Obriši filtere',
  'admin.users.title': 'Upravljanje korisnicima',
  'admin.users.total': 'korisnika',
  'admin.users.addUser': 'Dodaj korisnika',
  'admin.users.newUser': 'Novi korisnik',
  'admin.users.fullName': 'Ime i prezime',
  'admin.users.email': 'Email',
  'admin.users.password': 'Lozinka',
  'admin.users.roleClient': 'Klijent',
  'admin.users.roleOperator': 'Operater',
  'admin.users.roleAdmin': 'Admin',
  'admin.users.operatorCannotEditAdmin': 'Operater ne može da menja naloge administratora.',
  'admin.users.operatorCannotAssignAdmin': 'Operater ne može da dodeli ulogu Administrator.',
  'admin.users.noCompany': 'Bez dodeljene kompanije',
  'admin.users.create': 'Kreiraj korisnika',
  'admin.users.creating': 'Kreiranje...',
  'admin.users.created': 'Korisnik kreiran',
  'admin.users.createFailed': 'Greška pri kreiranju korisnika',
  'admin.users.fillRequired': 'Popunite sva obavezna polja',
  'admin.users.passwordMin': 'Lozinka mora imati najmanje 8 karaktera',
  'admin.users.loading': 'Učitavanje korisnika...',
  'admin.users.noUsers': 'Nema korisnika',
  'admin.users.name': 'Ime',
  'admin.users.emailCol': 'Email',
  'admin.users.roleCol': 'Uloga',
  'admin.users.companyCol': 'Kompanija',
  'admin.users.assignCompany': 'Dodeli kompaniju',
  'admin.users.none': 'Bez',
  'admin.users.assigned': 'Kompanija dodeljena',
  'admin.users.assignFailed': 'Greška pri dodeli kompanije',
  'admin.users.actions': 'Akcije',
  'admin.users.edit': 'Izmeni',
  'admin.users.resetPassword': 'Nova lozinka',
  'admin.users.editUser': 'Izmena korisnika',
  'admin.users.saveChanges': 'Sačuvaj izmene',
  'admin.users.updated': 'Korisnik je ažuriran',
  'admin.users.updateFailed': 'Ažuriranje korisnika nije uspelo',
  'admin.users.activeUser': 'Nalog aktivan',
  'admin.users.resetPasswordTitle': 'Postavi novu lozinku',
  'admin.users.newPassword': 'Nova lozinka',
  'admin.users.confirmPassword': 'Potvrda lozinke',
  'admin.users.passwordMismatch': 'Lozinke se ne poklapaju',
  'admin.users.passwordChanged': 'Lozinka je resetovana',
  'admin.users.passwordChangeFailed': 'Reset lozinke nije uspeo',
  'admin.users.serverConfig':
    'Dodajte SUPABASE_SERVICE_ROLE_KEY u okruženje servera da bi reset lozinke iz panela radio.',
  'admin.calls.title': 'Telefonski pozivi',
  'admin.calls.recent': 'nedavnih poziva',
  'admin.calls.addCall': 'Unesi poziv',
  'admin.calls.newCall': 'Novi poziv',
  'admin.calls.selectCompany': 'Kompanija *',
  'admin.calls.caller': 'Pozivalac',
  'admin.calls.callerPhone': 'Broj pozivaoca',
  'admin.calls.reason': 'Razlog poziva',
  'admin.calls.priority.low': 'Nizak',
  'admin.calls.priority.medium': 'Srednji',
  'admin.calls.priority.high': 'Visok',
  'admin.calls.duration': 'Trajanje (min, opciono)',
  'admin.calls.notes': 'Napomene',
  'admin.calls.handledBy': 'Primio / obradio',
  'admin.calls.recording': 'Snimak razgovora (opciono)',
  'admin.calls.recordingHint': 'Kliknite za audio (MP3, WAV, M4A…)',
  'admin.calls.save': 'Sačuvaj poziv',
  'admin.calls.saving': 'Čuvanje...',
  'admin.calls.saved': 'Poziv je sačuvan',
  'admin.calls.saveFailed': 'Greška pri čuvanju poziva',
  'admin.calls.fillRequired': 'Obavezno: kompanija, pozivalac, broj i razlog',
  'admin.calls.loading': 'Učitavanje...',
  'admin.calls.noCalls': 'Nema unetih poziva',
  'admin.calls.deleted': 'Poziv obrisan',
  'admin.calls.deleteFailed': 'Greška pri brisanju poziva',
  'admin.calls.openRecording': 'Snimak',
  'admin.calls.storageFailed': 'Otprema snimka nije uspela',
  'admin.calls.delete': 'Obriši poziv',
  'admin.docs.title': 'Upravljanje dokumentima',
  'admin.docs.recent': 'nedavnih dokumenata',
  'admin.docs.addDoc': 'Dodaj dokument',
  'admin.docs.newDoc': 'Novi dokument',
  'admin.docs.selectCompany': 'Odaberite kompaniju *',
  'admin.docs.docName': 'Naziv dokumenta',
  'admin.docs.description': 'Opis dokumenta',
  'admin.docs.uploadPdf': 'Otpremite PDF fajl',
  'admin.docs.category': 'Kategorija',
  'admin.docs.fileUrl': 'URL fajla (opciono)',
  'admin.docs.fileSize': 'Veličina fajla (npr. 284 KB)',
  'admin.docs.save': 'Sačuvaj dokument',
  'admin.docs.saving': 'Čuvanje...',
  'admin.docs.uploaded': 'Dokument dodat',
  'admin.docs.uploadFailed': 'Greška pri dodavanju dokumenta',
  'admin.docs.fillRequired': 'Kompanija i naziv dokumenta su obavezni',
  'admin.docs.operatorNoInvoiceCategory': 'Operater ne može da otpremi dokumente u kategoriji Fakture.',
  'admin.docs.loading': 'Učitavanje dokumenata...',
  'admin.docs.noDocs': 'Nema dokumenata',
  'admin.docs.deleted': 'Dokument obrisan',
  'admin.docs.deleteFailed': 'Greška pri brisanju dokumenta',
  'admin.docs.storageUploadFailed': 'Otprema fajla u storage nije uspela',
  'admin.docs.open': 'Otvori',
  'admin.docs.noFile': 'Za ovaj zapis nije sačuvan fajl.',
  'admin.docs.openFailed': 'Ne mogu da otvorim fajl.',
  'admin.docs.deleteFileFailed': 'Brisanje fajla iz storage-a nije uspelo',
  'admin.docs.cat.company': 'Kompanijska dokumenta',
  'admin.docs.cat.archive': 'Arhivska knjiga',
  'admin.docs.cat.mail': 'Pristigla pošta',
  'admin.docs.cat.tax': 'Poresko sanduče',
  'admin.docs.cat.registration': 'Registracija',
  'admin.docs.cat.lease': 'Zakup',
  'admin.docs.cat.accounting': 'Računovodstvo',
  'admin.docs.cat.other': 'Ostalo',

  'docCat.CompanyLegal': 'Pravna i registraciona dokumentacija (APR, statut, rešenja)',
  'docCat.StatutoryArchive': 'Arhiva i obavezno čuvanje dokumenata',
  'docCat.MailForwarding': 'Pošta i prosleđivanje (skenovi, pristigla pošta)',
  'docCat.TaxCompliance': 'Porezi, doprinosi i poreske prijave',
  'docCat.ContractsLeases': 'Ugovori i zakupi',
  'docCat.VirtualOfficeServices': 'Usluge virtuelne kancelarije',
  'docCat.Accounting': 'Knjigovodstvo i finansijski izveštaji',
  'docCat.Invoices': 'Fakture',
  'docCat.Other': 'Ostalo',
  'admin.invoices.title': 'Upravljanje fakturama',
  'admin.invoices.recent': 'nedavnih faktura',
  'admin.invoices.issue': 'Izdaj fakturu',
  'admin.invoices.newInvoice': 'Nova faktura',
  'admin.invoices.selectCompany': 'Odaberite kompaniju *',
  'admin.invoices.description': 'Opis',
  'admin.invoices.amount': 'Iznos',
  'admin.invoices.dueDate': 'Rok plaćanja',
  'admin.invoices.create': 'Kreiraj fakturu',
  'admin.invoices.creating': 'Kreiranje...',
  'admin.invoices.created': 'Faktura kreirana',
  'admin.invoices.createFailed': 'Greška pri kreiranju fakture',
  'admin.invoices.fillRequired': 'Popunite sva obavezna polja',
  'admin.invoices.loading': 'Učitavanje faktura...',
  'admin.invoices.noInvoices': 'Nema faktura',
  'admin.invoices.number': 'Broj fakture',
  'admin.invoices.companyCol': 'Kompanija',
  'admin.invoices.descCol': 'Opis',
  'admin.invoices.amountCol': 'Iznos',
  'admin.invoices.statusCol': 'Status',
  'admin.invoices.markedPaid': 'Označeno kao plaćeno',
  'admin.invoices.updateFailed': 'Greška pri ažuriranju fakture',
  'admin.invoices.deleted': 'Faktura obrisana',
  'admin.invoices.deleteFailed': 'Greška pri brisanju fakture',
  'admin.invoices.invoiceNumberLabel': 'Broj fakture (ručno)',
  'admin.invoices.issueDate': 'Datum izdavanja',
  'admin.invoices.attachmentLabel': 'Prilog fakture (PDF ili slika)',
  'admin.invoices.attachmentHint': 'Klijent vidi fajl u svom portalu pod dokumentima.',
  'admin.invoices.chooseFile': 'Izaberi fajl',
  'admin.invoices.uploadingDoc': 'Otpremanje priloga...',
  'admin.invoices.duplicateNumber': 'Broj fakture već postoji. Unesite drugi broj.',
  'admin.invoices.documentUploadFailed': 'Faktura je kreirana, ali otpremanje priloga nije uspelo',
  'admin.invoices.statusUpdated': 'Status fakture ažuriran',
  'admin.invoices.changeStatus': 'Promeni status',
  'admin.invoices.deleteInvoice': 'Obriši fakturu',
  'admin.invoices.stPending': 'Na čekanju',
  'admin.invoices.stPaid': 'Plaćeno',
  'admin.invoices.stOverdue': 'Prekoračeno',
  'admin.invoices.stCancelled': 'Otkazano',
  'admin.invoices.loadFailed': 'Greška pri učitavanju faktura',
  'admin.invoices.orphanTitle': 'Dokumenti bez fakture u sistemu',
  'admin.invoices.orphanHint': 'Ovi PDF-ovi su u Dokumentima, ali nisu registrovani kao fakture. Registrujte ih ovde da bi se pojavili u listi i da biste mogli da menjate status.',
  'admin.invoices.registerFromDocument': 'Registruj kao fakturu',
  'admin.invoices.registerConfirm': 'Sačuvaj fakturu',
  'admin.invoices.registeredFromDocument': 'Faktura je registrovana i povezana sa dokumentom',
  'admin.invoices.linkDocumentFailed': 'Faktura je kreirana, ali povezivanje dokumenta nije uspelo',
  'admin.invoices.editInvoice': 'Izmeni fakturu',
  'admin.invoices.saveChanges': 'Sačuvaj izmene',
  'admin.invoices.saving': 'Čuvanje...',
  'admin.invoices.updated': 'Faktura je ažurirana',
  'admin.companies.businessAddress': 'Poslovna adresa',
  'admin.companies.taxAddress': 'Poreska adresa / Izdvojena poslovna jedinica',
  'admin.companies.accountManager': 'Menadžer naloga',
  'admin.companies.accountManagerEmail': 'Email menadžera',
  'admin.companies.accountManagerPhone': 'Telefon menadžera',
  'admin.companies.phone': 'Telefon kompanije',
  'admin.companies.email': 'Email kompanije',
  'admin.companies.regNumber': 'Matični broj',
  'admin.companies.notes': 'Napomene',
  'admin.companies.sectionCompany': 'Podaci o kompaniji',
  'admin.companies.sectionManager': 'Menadžer naloga',
  'admin.companies.companyName': 'Naziv kompanije',
  'admin.companies.country': 'Zemlja',
  'admin.companies.registrationAddress': 'Adresa i grad registracije',
  'admin.companies.aprEmail': 'Zvaničan mail za APR',
  'admin.companies.aprPhone': 'Zvaničan telefon za APR',
  'admin.companies.ownerPhone': 'Pravi telefon vlasnika',
  'admin.companies.ownerEmail': 'Prava mail adresa vlasnika',
  'admin.companies.pib': 'PIB',
  'admin.companies.companyRegistrationDate': 'Datum registracije kompanije',
  'admin.companies.portalRegistrationDate': 'Datum registracije na portalu',
  'admin.companies.managerName': 'Ime menadžera',
  'admin.companies.managerEmail': 'Email menadžera',
  'admin.companies.managerContactPhone': 'Kontakt telefon',
  'admin.tasks.title': 'Zahtevi',
  'admin.tasks.noTasks': 'Nema zahteva',
  'admin.tasks.pending': 'Na čekanju',
  'admin.tasks.submitted': 'Podnet zahtev',
  'admin.tasks.ticketUrlPlaceholder': 'https://... link ka tiketu knjigovođe',
  'admin.tasks.saveUrl': 'Sačuvaj link',
  'admin.tasks.openTicket': 'Otvori tiket',
  'admin.tasks.urlSaved': 'Link je sačuvan.',
  'admin.tasks.urlSaveFailed': 'Greška pri čuvanju linka.',
  'admin.tasks.targetAccountant': 'Knjigovođa',
  'admin.tasks.targetSupport': 'Podrška',
  'admin.tasks.urgency': 'Hitnost',
  'admin.tasks.contactPref': 'Kontakt',
  'admin.tasks.tabAccountant': 'Knjigovođa',
  'admin.tasks.tabSupport': 'Podrška',
  'admin.tasks.emptyAccountant': 'Još nema zahteva za knjigovođu.',
  'admin.tasks.emptySupport': 'Još nema zahteva za podršku.',
  'admin.tasks.supportStatusReceived': 'Primljeno',
  'admin.tasks.supportStatusInProgress': 'U obradi',
  'admin.tasks.supportStatusCompleted': 'Završeno',
  'admin.tasks.supportStatusLabel': 'Status',
  'admin.tasks.supportStatusSaved': 'Status je ažuriran.',
  'admin.tasks.supportStatusSaveFailed': 'Greška pri ažuriranju statusa.',
  'client.docs.title': 'Dokumenti kompanije',
  'client.docs.statsLine': '{{count}} dokumenata · {{new}} novo',
  'client.docs.search': 'Pretraži dokumente...',
  'client.docs.all': 'Sve kategorije',
  'client.docs.dateFrom': 'Od datuma',
  'client.docs.dateTo': 'Do datuma',
  'client.docs.clearDates': 'Obriši datume',
  'client.docs.noResults': 'Nema pronađenih dokumenata',
  'client.docs.adjustSearch': 'Pokušajte da promenite pretragu ili filter',
  'client.docs.download': 'Preuzmi',
  'client.docs.preview': 'Pregled',
  'client.docs.noFile': 'Fajl nije dostupan.',
  'client.docs.openFailed': 'Ne mogu da otvorim fajl.',
  'client.docs.invoiceBadge': 'Faktura',
  'client.docs.loading': 'Učitavanje dokumenata...',
  'client.docs.loadFailed': 'Ne mogu da učitam dokumenta.',
  'client.docs.uploadTitle': 'Dodaj dokument',
  'client.docs.uploadHint': 'Otpremite fajl koji se odnosi na vašu kompaniju. Podržani su PDF, slike i uobičajeni office formati.',
  'client.docs.docNamePlaceholder': 'Naziv dokumenta (opciono)',
  'client.docs.chooseFile': 'Izaberi fajl',
  'client.docs.uploading': 'Otpremanje...',
  'client.docs.submitUpload': 'Pošalji dokument',
  'client.docs.uploaded': 'Dokument je otpremljen',
  'client.docs.uploadFailed': 'Otpremanje nije uspelo',
  'client.docs.fillRequired': 'Izaberite fajl i unesite naziv ako treba.',
  'client.invoices.title': 'Fakture i plaćanja',
  'client.company.address': 'Poslovna adresa',
  'client.company.taxAddress': 'Poreska adresa / Izd. posl. jedinica',
  'client.company.fieldNotSet': 'Nije uneto',
  'client.company.country': 'Zemlja',
  'client.company.registrationAddress': 'Adresa i grad registracije',
  'client.company.companyEmail': 'Email kompanije',
  'client.company.aprEmail': 'Zvaničan mail za APR',
  'client.company.aprPhone': 'Zvaničan telefon za APR',
  'client.company.ownerPhone': 'Pravi telefon vlasnika',
  'client.company.ownerEmail': 'Prava mail adresa vlasnika',
  'client.company.pib': 'PIB',
  'client.company.notesCompany': 'Napomene',
  'client.company.companyRegDate': 'Datum registracije kompanije',
  'client.company.portalRegDate': 'Datum registracije na portalu',
  'client.company.start': 'Početak usluge',
  'client.company.renewal': 'Sledeće obnavljanje',
  'client.company.plan': 'Plan',
  'client.company.manager': 'Vaš menadžer naloga',
  'client.company.noCompany': 'Nema dodeljene kompanije.',
  'client.company.contactManager': 'Kontaktirajte menadžera naloga za pomoć.',
  'company.plan.group.vo': 'Virtuelna kancelarija',
  'company.plan.group.cw': 'Coworking',
  'company.plan.vo_starter': 'Starter',
  'company.plan.vo_business': 'Business',
  'company.plan.vo_premium': 'Premium',
  'company.plan.cw_hot_desk': 'Hot desk',
  'company.plan.cw_fixed_desk': 'Fiksni sto',
  'company.plan.cw_private_office': 'Privatna kancelarija',
  'client.kpi.docs': 'Ukupno dokumenata',
  'client.kpi.invoices': 'Aktivne fakture',
  'client.kpi.overdue': 'Fakture u kašnjenju',
  'client.kpi.renewal': 'Sledeće obnavljanje',
  'client.kpi.docsSub': '{{count}} novih ovog meseca',
  'client.kpi.invoicesSub': '{{count}} na plaćanje',
  'client.kpi.overdueSubOk': 'Sve fakture su u roku',
  'client.kpi.overdueSubAction': 'Potrebna intervencija',
  'client.kpi.renewalValueDays': '{{count}} dana',
  'client.kpi.renewalDue': 'Rok: {{date}}',
  'client.kpi.renewalSubNone': 'Obnavljanje nije podešeno',
  'client.calls.title': 'Primljeni pozivi',
  'client.calls.caller': 'Pozivalac',
  'client.calls.phone': 'Telefon',
  'client.calls.date': 'Datum i vreme',
  'client.calls.duration': 'Trajanje',
  'client.calls.notes': 'Napomene',
  'client.calls.noCalls': 'Nema primljenih poziva',
  'client.calls.minutes': 'min',
  'client.calls.reason': 'Razlog',
  'client.calls.priorityLow': 'Nizak prioritet',
  'client.calls.priorityMedium': 'Srednji prioritet',
  'client.calls.priorityHigh': 'Visok prioritet',
  'client.calls.openRecording': 'Snimak razgovora',
  'client.calls.openRecordingFailed': 'Snimak nije moguće otvoriti',
  'client.task.button': 'Podnesi zahtev knjigovođi',
  'client.task.title': 'Novi zahtev za knjigovođu',
  'client.task.subtitle': 'Opišite šta vam treba. Referentni cenovnik otvorite po potrebi.',
  'client.task.taskTitle': 'Naslov zahteva',
  'client.task.taskDesc': 'Opis zahteva',
  'client.task.send': 'Pošalji zahtev',
  'client.task.sending': 'Slanje...',
  'client.task.sent': 'Zahtev je poslat!',
  'client.task.failed': 'Greška pri slanju zahteva',
  'client.task.fillRequired': 'Naslov zahteva je obavezan',
  'client.task.pricing': 'Cenovnik usluga',
  'client.task.pricingInfo': 'Informacije o cenama',
  'client.task.selectServiceLabel': 'Usluga iz cenovnika',
  'client.task.selectServicePlaceholder': 'Izaberite uslugu (automatski popunjava naslov i opis)',
  'client.task.lblCategory': 'Kategorija',
  'client.task.lblService': 'Usluga',
  'client.task.lblPriceRsd': 'Cena (klijenti, RSD)',
  'client.task.lblUnit': 'Jedinica',
  'client.task.autoDescFooter': 'Dopunite rok, posebne zahteve ili pitanja ispod.',
  'client.task.fullPricingOnSite': 'Pogledaj kompletan cenovnik na sajtu',
  'client.support.title': 'Kontakt podrške',
  'client.support.subtitle': 'Opišite problem. Javićemo vam se što pre.',
  'client.support.fieldTitle': 'Naslov',
  'client.support.fieldMessage': 'Poruka',
  'client.support.urgency': 'Hitnost',
  'client.support.urgencyLow': 'Niska',
  'client.support.urgencyMedium': 'Srednja',
  'client.support.urgencyHigh': 'Visoka',
  'client.support.contactPref': 'Kako želite da vas kontaktiramo?',
  'client.support.contactEmail': 'Email',
  'client.support.contactPhone': 'Telefon',
  'client.support.contactBoth': 'Email ili telefon',
  'client.support.send': 'Pošalji',
  'client.support.sending': 'Šaljem...',
  'client.support.sent': 'Poruka je poslata.',
  'client.support.failed': 'Slanje nije uspelo. Pokušajte ponovo.',
  'client.support.fillTitle': 'Naslov je obavezan.',
  'client.support.fillMessage': 'Poruka je obavezna.',
  'client.taskRequests.title': 'Zahtevi',
  'client.taskRequests.loading': 'Učitavanje zahteva...',
  'client.taskRequests.noTasks': 'Još nema podnetih zahteva',
  'client.taskRequests.pending': 'Na čekanju',
  'client.taskRequests.submitted': 'Podnet zahtev',
  'client.taskRequests.createdAt': 'Kreiran',
  'client.taskRequests.submittedAt': 'Prosleđen knjigovođi',
  'client.taskRequests.openTicket': 'Otvori tiket',
  'client.taskRequests.waitingForTicket': 'Čeka se da admin unese link ka tiketu',
  'client.taskRequests.targetAccountant': 'Knjigovođa',
  'client.taskRequests.targetSupport': 'Podrška',
  'client.taskRequests.urgency': 'Hitnost',
  'client.taskRequests.contactPref': 'Kontakt',
  'client.taskRequests.tabAccountant': 'Knjigovođa',
  'client.taskRequests.tabSupport': 'Podrška',
  'client.taskRequests.emptyAccountant': 'Još nema zahteva za knjigovođu.',
  'client.taskRequests.emptySupport': 'Još nema zahteva za podršku.',
  'client.taskRequests.supportStatusReceived': 'Primljeno',
  'client.taskRequests.supportStatusInProgress': 'U obradi',
  'client.taskRequests.supportStatusCompleted': 'Završeno',
  'client.taskRequests.updatedAt': 'Ažurirano',
  'login.title': 'Prijavite se',
  'login.subtitle': 'Klijent portal',
  'login.desc': 'Unesite vaše podatke za pristup portalu',
  'login.email': 'Email adresa',
  'login.password': 'Lozinka',
  'login.signIn': 'Prijavite se',
  'login.signingIn': 'Prijavljivanje...',
  'login.fillRequired': 'Unesite email i lozinku',
  'login.invalidCredentials': 'Pogrešan email ili lozinka',
  'login.forgotPassword': 'Zaboravio sam lozinku',
  'login.forgotTitle': 'Reset lozinke',
  'login.forgotDesc': 'Unesite email adresu naloga. Poslaćemo vam link za postavljanje nove lozinke.',
  'login.sendResetLink': 'Pošalji link',
  'login.sendingReset': 'Šaljem…',
  'login.resetSent': 'Ako nalog postoji, proverite email. Poslali smo uputstvo za reset lozinke.',
  'login.resetEmailRequired': 'Unesite email adresu.',
  'login.resetFailed': 'Slanje nije uspelo. Pokušajte ponovo.',
  'login.backToSignIn': 'Nazad na prijavu',
  'login.resetLoading': 'Učitavanje…',
  'login.resetPasswordTitle': 'Nova lozinka',
  'login.resetPasswordDesc': 'Unesite novu lozinku za vaš nalog.',
  'login.newPassword': 'Nova lozinka',
  'login.confirmPassword': 'Potvrdite lozinku',
  'login.passwordMismatch': 'Lozinke se ne poklapaju.',
  'login.passwordTooShort': 'Lozinka mora imati najmanje 6 karaktera.',
  'login.saveNewPassword': 'Sačuvaj lozinku',
  'login.savingPassword': 'Čuvam…',
  'login.passwordUpdated': 'Lozinka je ažurirana.',
  'login.redirectingToLogin': 'Preusmeravamo vas na prijavu…',
  'login.resetInvalid': 'Link za reset nije važeći ili je istekao. Zatražite novi na stranici za prijavu.',
  'admin.companies.addNew': 'Dodaj novu kompaniju',
  'admin.companies.save': 'Sačuvaj kompaniju',
  'admin.companies.saveChanges': 'Sačuvaj izmene',
  'admin.companies.edit': 'Uredi kompaniju',
  'admin.companies.editTitle': 'Uredi kompaniju',
  'admin.companies.editDrawerHint': 'Izmenite polja ispod, zatim sačuvajte.',
  'admin.companies.view': 'Pregled',
  'admin.companies.delete': 'Obriši',
  'admin.companies.edit2': 'Uredi',
  'admin.companies.noMatch': 'Nema kompanija koje odgovaraju pretrazi',
  'admin.companies.loading': 'Učitavanje kompanija...',
  'admin.companies.taxLabel': 'Poreska',
  'admin.companies.colName': 'Kompanija',
  'admin.companies.colCountry': 'Zemlja',
  'admin.companies.colPlan': 'Plan',
  'admin.companies.colStatus': 'Status',
  'admin.companies.detailBadge': 'Kompanija',
  'admin.companies.sectionInfo': 'Podaci o kompaniji',
  'admin.companies.sectionDocuments': 'Dokumenti',
  'admin.companies.sectionFinance': 'Finansije i fakture',
  'admin.companies.financeTotalPaid': 'Ukupno plaćeno (sve vreme)',
  'admin.companies.financePaidCount': 'Plaćene fakture',
  'admin.companies.financePending': 'Na čekanju',
  'admin.companies.financeOverdue': 'U kašnjenju',
  'admin.companies.detailNoDocuments': 'Još nema dokumenata za ovu kompaniju.',
  'admin.companies.recentInvoices': 'Nedavne fakture',
  'admin.companies.openDoc': 'Otvori',
  'admin.companies.detailLoading': 'Učitavanje…',
  'admin.companies.serviceStart': 'Početak usluge',
  'admin.companies.nextRenewal': 'Sledeće obnavljanje',
  'admin.companies.searchPlaceholder': 'Pretraži kompanije...',
  'admin.companies.countOf': 'od',
  'admin.companies.companiesWord': 'kompanija',
  'admin.companies.addShort': 'Dodaj',
  'admin.companies.refreshTitle': 'Osveži',
  'admin.companies.filterAll': 'Sve',
  'admin.companies.statusActive': 'Aktivna',
  'admin.companies.statusPending': 'Na čekanju',
  'admin.companies.statusSuspended': 'Suspendovana',
  'admin.companies.statusArchived': 'Arhivirana',
  'admin.revenue.title': 'Mesečni prihod',
  'admin.revenue.subtitle': 'Poslednjih 12 meseci · plaćene fakture',
  'admin.revenue.totalLabel': 'Ukupno (12m):',
  'admin.revenue.invoices': 'faktura',
  'admin.quick.title': 'Brze akcije',
  'admin.quick.uploadDoc': 'Otpremi dokument',
  'admin.quick.uploadDocDesc': 'Dodaj dokument kompaniji',
  'admin.quick.addCompany': 'Dodaj kompaniju',
  'admin.quick.addCompanyDesc': 'Registruj novog klijenta',
  'admin.quick.issueInvoice': 'Izdaj fakturu',
  'admin.quick.issueInvoiceDesc': 'Kreiraj novu fakturu',
  'admin.quick.addUser': 'Dodaj korisnika',
  'admin.quick.addUserDesc': 'Dodeli pristup portalu',
  'admin.quick.addCall': 'Dodaj poziv',
  'admin.quick.addCallDesc': 'Unesi primljeni poziv',
  'admin.quick.generateReport': 'Generiši izveštaj',
  'admin.quick.generateReportDesc': 'Izvezi izveštaj kompanije',
  'admin.quick.portalSettings': 'Podešavanja portala',
  'admin.quick.portalSettingsDesc': 'Upravljaj konfiguracijom',
  'admin.quick.pendingTasks': 'Zadaci na čekanju',
  'admin.quick.noTasks': 'Nema zadataka na čekanju',
  'admin.quick.portalHealth': 'Zdravlje portala',
  'admin.quick.docCoverage': 'Pokrivenost dokumentima',
  'admin.quick.collectionRate': 'Stopa naplate faktura',
  'admin.quick.activeCompanies': 'Aktivne kompanije',
  'admin.activity.title': 'Nedavna aktivnost',
  'admin.activity.subtitle': 'Aktivnosti portala uživo',
  'admin.activity.viewAll': 'Pogledaj ceo dnevnik aktivnosti',
  'admin.activity.noActivity': 'Nema nedavnih aktivnosti',
  'admin.activity.docUploaded': 'Dokument otpremljen za',
  'admin.activity.invoiceOverdue': 'Faktura kasni -',
  'admin.activity.paymentReceived': 'Plaćanje primljeno -',
  'admin.activity.invoiceIssued': 'Faktura izdata -',
  'admin.activity.newPending': 'Nova kompanija čeka odobrenje',
  'admin.activity.newOnboarded': 'Nova kompanija registrovana',
  'admin.activity.contactForm': 'Nova poruka sa kontakt forme',
  'admin.kpi.activeCompanies': 'Aktivne kompanije',
  'admin.kpi.currentlyActive': 'Trenutno aktivne',
  'admin.kpi.pendingDocs': 'Dokumenti na čekanju',
  'admin.kpi.awaitingUpload': 'Čekaju otpremanje',
  'admin.kpi.outstandingInvoices': 'Neplaćene fakture',
  'admin.kpi.pendingPayment': 'Čekaju plaćanje',
  'admin.kpi.overdueInvoices': 'Fakture u kašnjenju',
  'admin.kpi.actionRequired': 'Potrebna akcija',
  'admin.kpi.revenue': 'Prihod -',
  'admin.kpi.paidThisMonth': 'Plaćene fakture ovog meseca',
  'admin.kpi.newCompanies': 'Nove kompanije (30d)',
  'admin.kpi.onboardedThisMonth': 'Registrovane ovog meseca',
  'admin.kpi.urgent': 'HITNO',
  'admin.kpi.contactForm': 'Kontakt forma',
  'admin.kpi.contactFormSub': 'Ukupno upita sa sajta',
  'admin.kpi.contactFormUnread': 'Nepročitana kontakt forma',
  'admin.kpi.contactFormUnreadSub': 'Još nisu pregledani',
  'client.notif.document': 'Novi dokument:',
  'client.notif.invoiceIssued': 'Faktura:',
  'client.notif.invoicePaid': 'Plaćena faktura:',
  'client.notif.task': 'Zahtev',
  'client.notif.call': 'Poziv',
  'client.invoices.loading': 'Učitavanje faktura...',
  'client.invoices.noInvoices': 'Nema faktura',
  'client.invoices.pending': 'čeka plaćanje',
  'client.invoices.viewAll': 'Pogledaj sve',
  'client.invoices.colInvoice': 'Faktura',
  'client.invoices.colDesc': 'Opis',
  'client.invoices.colIssued': 'Datum izdavanja',
  'client.invoices.colDue': 'Rok plaćanja',
  'client.invoices.colAmount': 'Iznos',
  'client.invoices.colStatus': 'Status',
  'client.invoices.view': 'Pogledaj fakturu',
  'client.invoices.downloadAttachment': 'Preuzmi priloženi fajl',
  'client.invoices.openAttachment': 'Otvori priloženi fajl',
  'client.invoices.noAttachment': 'Uz ovu fakturu nije priložen fajl.',
  'client.invoices.openFailed': 'Ne mogu da otvorim fajl.',
  'client.invoices.downloadedOk': 'Fajl za fakturu {{n}} je otvoren',
  'portal.languageHint': 'Promenite jezik u gornjem meniju',
  'portal.emailLanguage': 'Jezik obaveštenja na email',
  'portal.emailLanguageHint':
    'Transakcioni mejlovi iz portala (fakture, dokumenti od tima, pozivi, podsetnik za kašnjenje) stižu na izabranom jeziku.',
  'portal.emailLanguageSaved': 'Jezik mejlova je sačuvan.',

  // VirtualOfficeSection
  'vo.sectionTitle': 'Srpska poslovna adresa,\nbez troškova kancelarije',
  'vo.sectionDesc': 'Uspostavite verodostojno, zakonski registrovano srpsko poslovno prisustvo od prvog dana - bez troškova i obaveza fizičkog prostora.',
  'vo.benefit1.title': 'Prestižna beogradska adresa',
  'vo.benefit1.desc': 'Topčiderska ulica, opština Savski venac - poslovna zona u zaštićenom zelenilu, blizu centra Beograda.',
  'vo.benefit2.title': 'Prijem i prosleđivanje pošte',
  'vo.benefit2.desc': 'Primamo, skeniramo i prosleđujemo vašu poslovnu korespondenciju gde god da se nalazite.',
  'vo.benefit3.title': 'Podrška pri registraciji',
  'vo.benefit3.desc': 'Pomažemo pri APR registraciji kompanije, obezbeđujući potrebnu adresnu dokumentaciju.',
  'vo.benefit4.title': 'Pogodno za strane kompanije',
  'vo.benefit4.desc': 'Idealno za međunarodne kompanije kojima je potrebno zakonsko srpsko prisustvo bez fizičkog preseljenja.',
  'vo.benefit5.title': 'Zakonski usklađeno',
  'vo.benefit5.desc': 'Potpuno usklađeno sa srpskim privrednim pravom i zahtevima APR registracije.',
  'vo.benefit6.title': 'Aktivno za 48h',
  'vo.benefit6.desc': 'Vaša adresa i pristup portalu su spremni u roku od dva radna dana od potpisivanja.',
  'vo.legalHighlight':
    'Jedini u Srbiji nudimo 100% legalnu virtuelnu kancelariju, u skladu sa svim zakonima Republike Srbije.',
  'vo.whoFor': 'Za koga je namenjeno',
  'vo.whoFor1': 'Strane kompanije koje ulaze na srpsko tržište',
  'vo.whoFor2': 'E-commerce preduzeća kojima je potrebna srpska PDV adresa',
  'vo.whoFor3': 'Slobodnjaci i konsultanti kojima je potrebna profesionalna poslovna adresa',
  'vo.whoFor4': 'Kompanije koje smanjuju fizički kancelarijski prostor',
  'vo.whoFor5': 'Startapi kojima je potrebna registrovana adresa pre zapošljavanja',
  'vo.plansTitle': 'Paket virtuelne kancelarije',
  'vo.plansDesc':
    'Jedan paket obuhvata sve navedeno ispod. Adresu i poresku upravu birate prema poslovnim i poreskim prioritetima.',
  'vo.requestQuote': 'Zatražite ponudu',
  'vo.pack.title': 'Virtuelna kancelarija',
  'vo.pack.tagline': 'Jedna cena, jedan paket - adresa, pošta i portal.',
  'vo.pack.priceRsd': '3.500 RSD',
  'vo.pack.priceEur': '~30 EUR',
  'vo.pack.annualNote': '2 meseca gratis pri godišnjem plaćanju',
  'vo.pack.f1': 'Poslovna adresa u Beogradu ili Kovinu (PU Pančevo); Loznica uskoro, iskažite interesovanje',
  'vo.pack.f2': 'Email obaveštenje o pristigloj pošti',
  'vo.pack.f3':
    'Skeniranje pristigle pošte, slanje skenova emailom i postavljanje na korisnički portal',
  'vo.pack.f4': 'Prijem u zajedničko sanduče',
  'vo.pack.f5': 'Zaseban registrator za dokumentaciju',
  'vo.pack.f6': 'Popust na korišćenje coworking prostora i sale za sastanke',
  'vo.pack.f7': 'Pristup digitalnom portalu za praćenje dokumentacije',

  'vo.addOns.tag': 'DODATNE USLUGE',
  'vo.addOns.title': 'Dodatne usluge uz virtuelnu kancelariju',
  'vo.addOns.subtitle': 'Proširite paket po potrebi – transparentne stavke, jasne cene gde god je moguće fiksirati ih.',
  'vo.addOns.1.title': 'Telefonska centrala',
  'vo.addOns.1.desc':
    'Primali pozive umesto vas. Naš broj možete registrovati u APR-u; sve primljene pozive obrađujemo i obaveštavamo vas o pozivaocu.',
  'vo.addOns.1.price': '+500 RSD / mesec',
  'vo.addOns.2.title': 'Tumačenje dokumenata i poresko savetovanje',
  'vo.addOns.2.desc':
    'Naš tim advokata, po specijalnoj ceni, može da vam protumači sve tipove dokumenata.',
  'vo.addOns.2.price': 'Po dogovoru',
  'vo.addOns.3.title': 'Podnošenje EKO takse',
  'vo.addOns.3.desc': 'Uslužno podnošenje eko takse za navedene opštine u kojima poslujemo.',
  'vo.addOns.3.price': '3.000 RSD / prijava',
  'vo.addOns.4.title': 'Posebno sanduče i pločica',
  'vo.addOns.4.desc':
    'Istaknite se posebnim sandučetom i pločicom na sandučetu. Dimenzije sandučeta 370 × 250 × 90 mm.',
  'vo.addOns.4.price': '+1.000 RSD / mesec',
  'vo.addOns.5.title': 'Sala za sastanke',
  'vo.addOns.5.desc':
    'Rezervišite salu za sastanke u našem prostoru po promotivnim cenama.',
  'vo.addOns.5.price': 'Po dogovoru',
  'vo.addOns.6.title': 'Fizičko prosleđivanje pošte',
  'vo.addOns.6.desc':
    'Jedan dokument ili više pošiljki – šaljemo brzom poštom ili preporučenom, po vašem zahtevu.',
  'vo.addOns.6.price': '+500 RSD + PTT',

  'vo.extraBenefits.tag': 'VIRTUELNA KANCELARIJA',
  'vo.extraBenefits.title': 'Benefiti virtuelne kancelarije',
  'vo.extraBenefits.desc': 'Dodatne prednosti koje vaša kompanija dobija uz registrovanu poslovnu adresu.',
  'vo.extraBenefits.1.title': 'Zaštita adrese poslovanja',
  'vo.extraBenefits.1.desc':
    'Vaša registrovana adresa ostaje stabilna i jasno vidljiva u APR registru, uz profesionalno rukovanje korespondencijom kako bi vaša poslovna adresa bila zaštićena od zloupotrebe.',
  'vo.extraBenefits.2.title': 'Zaštita broja telefona',
  'vo.extraBenefits.2.desc':
    'Poslovni kontakt može biti usmeren preko naše adrese, tako da privatni brojevi i lični podaci ostanu odvojeni od javnog poslovnog profila.',
  'vo.extraBenefits.3.title': 'Jedna od povoljnijih poreskih zona u Beogradu',
  'vo.extraBenefits.3.desc':
    'Lokacija u zoni koja spada među povoljnije u gradu, što može pozitivno uticati na ukupne operativne i poreske troškove.',
  'vo.extraBenefits.4.title': 'Sanduče i pločica sa imenom uvek na adresi',
  'vo.extraBenefits.4.desc':
    'Fizičko sanduče i oznaka sa imenom kompanije uvek su prisutni na adresi, kako bi se izbeglo vraćanje pošte i problemi sa inspekcijama koje zahtevaju ovakvu oznaku i redovan prijem pošte na licu mesta.',
  'vo.extraBenefits.5.title': 'Arhiviranje pošte i arhivska knjiga',
  'vo.extraBenefits.5.desc':
    'Pristigla pošta se evidentira i arhivira u skladu sa pravilima, uz sigurno mesto za vođenje i čuvanje arhivske knjige.',
  'vo.extraBenefits.6.title': 'Prijem poreskog inspektora',
  'vo.extraBenefits.6.desc':
    'Uvek je dostupna ovlašćena osoba koja može primiti poreskog inspektora i obezbediti potrebnu dokumentaciju na licu mesta.',

  'pausalBanner.text':
    'Naša kancelarija se nalazi u zoni zaštite zelenila, opština Savski venac. Pored toga nudimo registrovanu adresu u Kovinu (PU Pančevo). Lokacija Loznica uskoro, iskažite interesovanje za ovu opciju.',
  'pausalBanner.button': 'Kalkulator paušalnog poreza',
  'pausalBanner.textInlineLink':
    'Pogledaj da li tvoja delatnost može da se paušalno oporezuje na ovom linku.',
  'pausalBanner.aria': 'Paušalni porez – link ka kalkulatoru Poreske uprave',

  // CoworkingSection
  'cw.sectionTitle': 'Profesionalni radni prostor\nu srcu Beograda',
  'cw.sectionDesc': 'Dizajnirano za produktivnost i saradnju. Radite zajedno sa drugim profesionalcima u čistom, tihom, poslovno orijentisanom okruženju.',
  'cw.amenity1': 'Gigabitni internet',
  'cw.amenity1.desc': '1 Gbps fiber',
  'cw.amenity2': 'Kafa i kuhinja',
  'cw.amenity2.desc': 'Potpuno opremljeno',
  'cw.amenity3': 'Dva monitora',
  'cw.amenity3.desc': 'Na zahtev',
  'cw.amenity4': 'Sale za sastanke',
  'cw.amenity4.desc': '3 dostupne',
  'cw.amenity5': 'Fleksibilno rezervisanje',
  'cw.amenity5.desc': 'Dan ili mesec',
  'cw.amenity6': '24h siguran pristup',
  'cw.amenity6.desc': 'Ulaz karticom',
  'cw.plan.hotDesk.desc': 'Fleksibilan otvoreni sto, dostupan svaki radni dan. Savršeno za slobodnjake i honorarne radnike.',
  'cw.plan.hotDesk.f1': 'Bilo koji dostupan sto',
  'cw.plan.hotDesk.f2': 'Pristup radnim danima',
  'cw.plan.hotDesk.f3': 'Skladište u ormariću',
  'cw.plan.hotDesk.f4': 'Krediti za salu za sastanke (2h/mes)',
  'cw.plan.dedicated.desc': 'Vaš sopstveni rezervisani sto, zaključano skladište i stalni radni prostor u našem coworking prostoru.',
  'cw.plan.dedicated.f1': 'Rezervisani sto 24/7',
  'cw.plan.dedicated.f2': 'Zaključani ormarić',
  'cw.plan.dedicated.f3': 'Dostupan dodatak poslovne adrese',
  'cw.plan.dedicated.f4': 'Krediti za salu za sastanke (5h/mes)',
  'cw.plan.private.desc': 'Potpuno zatvorena privatna kancelarija za 1–4 osobe. Uključuje zaključano skladište i dedicirane sate sale za sastanke.',
  'cw.plan.private.f1': 'Zatvorena privatna kancelarija',
  'cw.plan.private.f2': 'Do 4 radne stanice',
  'cw.plan.private.f3': 'Dedicirana sala za sastanke (10h/mes)',
  'cw.plan.private.f4': 'Prilagođeni brending na vratima',

  // AccountingSection
  'acc.sectionTitle': 'Profesionalna poslovna podrška\nza Srbiju',
  'acc.sectionDesc': 'Propušten rok kod Poreske uprave, pogrešna PDV prijava ili neispravna adresa mogu značiti kazne i probleme u poslovanju - posebno ako ne govorite srpski i ne poznajete APR propise. Naš tim na pet jezika preuzima tu složenost, prati rokove umesto vas i čuva vas od grešaka, da se vi fokusirate na posao.',
  'acc.svc1.title': 'Knjigovodstvo i računovodstvo',
  'acc.svc1.desc': 'Mesečno knjigovodstvo, priprema finansijskih izveštaja i izveštavanje o usklađenosti u skladu sa srpskim računovodstvenim standardima (MSFI/MRS).',
  'acc.svc1.tag1': 'Mesečni izveštaji',
  'acc.svc1.tag2': 'MSFI/MRS usklađeno',
  'acc.svc2.title': 'Poreska i PDV registracija',
  'acc.svc2.desc': 'Bavimo se vašom PDV registracijom, kvartalnim PDV prijavama, prijavom poreza na dobit i svim zakonskim rokovima kod Poreske uprave.',
  'acc.svc2.tag1': 'PDV registracija',
  'acc.svc2.tag2': 'Kvartalne prijave',
  'acc.svc3.title': 'Podrška za pravne dokumente',
  'acc.svc3.desc': 'Priprema i pregled ugovora, ugovora o radu i poslovnih dokumenata - izrađenih u skladu sa srpskim privrednim i radnim pravom.',
  'acc.svc3.tag1': 'Izrada ugovora',
  'acc.svc3.tag2': 'Radno pravo',
  'acc.svc4.title': 'Višejezično savetovanje',
  'acc.svc4.desc': 'Naš tim pruža konsultacije na srpskom, engleskom, ruskom, turskom i nemačkom - obezbeđujući jasnu komunikaciju za međunarodne klijente.',
  'acc.svc4.tag1': '5 jezika',
  'acc.svc4.tag2': 'Međunarodni klijenti',
  'acc.stat1.label': 'Godina iskustva',
  'acc.stat1.sub': 'u srpskom poslovnom pravu',
  'acc.stat2.label': 'Podržanih klijenata',
  'acc.stat2.sub': 'lokalni i međunarodni',
  'acc.stat3.label': 'Jezika',
  'acc.stat3.sub': 'jezici konsultacija',
  'acc.stat4.label': 'Poreskih prijava',
  'acc.stat4.sub': 'od 2014. godine',
  'acc.cta.title': 'Zakažite besplatne konsultacije',
  'acc.cta.desc': 'Razgovarajte sa jednim od naših računovodstvenih ili pravnih savetnika o vašoj specifičnoj poslovnoj situaciji. Dostupno na srpskom, engleskom, ruskom, turskom i nemačkom.',
  'acc.cta.btn': 'Zakažite poziv',
  'acc.pricing.show': 'Prikaži cenovnik',
  'acc.pricing.hide': 'Sakrij cenovnik',
  'acc.pricing.footer': 'Sve cene su u dinarima (RSD). Minimalne cene, predmet su dogovora. Oznaka ✓ označava usluge koje se mogu pružiti u potpunosti online.',

  // TrustSection
  'trust.statsTitle': 'Poverenje kompanija iz celog sveta',
  'trust.stat1': 'Registrovanih kompanija',
  'trust.stat2': 'Upravljanih dokumenata',
  'trust.stat3': 'Godina poslovanja',
  'trust.stat4': 'Zemalja',
  'trust.trustedBy': 'Poverenje kompanija iz Evrope i šire',
  'trust.testimonialsTag': 'Iskustva klijenata',
  'trust.testimonialsTitle': 'Šta kažu naši klijenti',
  'trust.test1.text':
    'Trebala nam je srpska poslovna adresa za proširenje EU operacija. Top14 kancelarijska rešenja su sve pokrile: registraciju, dokumente i prosleđivanje pošte. Klijentski portal čini sve neverovatno lakim.',
  'trust.test1.highlight': 'Registrovano za manje od 48 sati',
  'trust.test2.text':
    'Kao ruska preduzetnica, trebao mi je pouzdan partner u Srbiji. Top14 je pružio višejezičnu podršku; PDV registracija i ceo proces bili su besprekorni od početka do kraja.',
  'trust.test2.highlight': 'Višejezična podrška je napravila razliku',
  'trust.test3.text':
    'Coworking prostor je profesionalan i dobro opremljen. Top14 kancelarijska rešenja su mi baza u Beogradu kada sam u Srbiji: odličan internet, mir i tim uvek spreman da pomogne.',
  'trust.test3.highlight': 'Moj omiljeni beogradski radni prostor',

  // PartnersSection (marketing home)
  'partners.tag': 'Partneri',
  'partners.title': 'Naši partneri',
  'partners.desc':
    'Kompanije koje dopunjavaju Top14 ekosistem: digitalno prisustvo, finansije, AI i edukacija.',
  'partners.evi.name': 'EVI Solutions',
  'partners.evi.desc':
    'Izrada sajta često je prvi korak ka ozbiljnom poslovanju. Pored toga, EVI razvija i kompletne portale, internet prodavnice i aplikacije, uz profesionalno održavanje IT infrastrukture, radi stabilnog digitalnog sloja dok skalirate.',
  'partners.tim011.name': 'Tim011 Digital',
  'partners.tim011.desc':
    'Partner za brzo pokretanje preduzetništva ili kompanije, sa naglaskom na brzinu i digitalno knjigovodstvo. Pouzdan saveznik u svakodnevnom poslovanju i jasnija optimizacija poreskih obaveza, da vi vodite posao, a ne papirologiju.',
  'partners.intrascope.name': 'Intrascope',
  'partners.intrascope.desc':
    'Jedinstvena AI infrastruktura za ceo tim: vodeći modeli na jednom mestu, zajednički kontekst i kontrola unutar kompanije. Sa promo kodom TOP150 ostvarujete 150 USD uštede na prvu kupovinu godišnjeg plana.',
  'partners.capitaale.name': 'Capitaale',
  'partners.capitaale.desc':
    'Capitaale je aplikacija za preduzetnike koji naplaćuju iz inostranstva. Pravi saldo u dinarima posle kursa banke, paušalni limit uživo, upozorenje kada jedan klijent pređe 70% prihoda i faktura u EUR ili USD za 60 sekundi. Prvih 7 dana besplatno.',

  // Footer hardcoded items
  'footer.businessAddress': 'Poslovna adresa',
  'footer.legalAssistance': 'Pravna pomoć',
  'footer.companyRegistration': 'Registracija kompanije',

  // Blog
  'blog.subtitle': 'Vodiči o virtuelnoj kancelariji, otvaranju firme i poslovnoj adresi u Beogradu i Srbiji.',
  'blog.readMore': 'Pročitajte više',
  'blog.backToBlog': 'Nazad na blog',
  'blog.related': 'Povezani članci',
  'blog.published': 'Objavljeno',
  'blog.minRead': 'min čitanja',
  'blog.ctaTitle': 'Spremni za virtuelnu kancelariju u Beogradu?',
  'blog.ctaDesc': 'Zakažite konsultacije i saznajte kako Top14 može da podrži vaše poslovanje u Srbiji.',
  'blog.ctaBtn': 'Kontakt',
  'blog.authorTeam': 'Tim Top14',
  'blog.sources': 'Korisni linkovi',
  'blog.breadcrumbHome': 'Početna',
};

export default sr;
